import React from 'react'
import { Button } from './../../components'
import { Row, Col } from 'react-bootstrap'
import { ImageWrapper, TextOverLay, Title, Content } from './styled'
import { useHistory } from 'react-router-dom'
import { slugify } from './../../common'

const About = (props) => {

    const history = useHistory();
    const handleClick = () => {
        history.push(props?.content_group.button.url)
    }

    return (
        <>
            {
                props.alignment === 'text_right'
                ? (
                        <Row>
                            <Col
                                lg={6}
                                md={12}
                            >
                                <ImageWrapper>
                                    <img src={props?.image_group.image.url} alt={props?.image_group.alt} />
                                    <TextOverLay className='d-none d-lg-flex'>
                                        {props?.image_group.text_overlay}
                                    </TextOverLay>
                                </ImageWrapper>
                                </Col>

                                <Col 
                                    lg={{
                                    span: 5,
                                    offset: 1
                                    }}
                                    md={12}
                                    className='d-flex flex-column align-items-start justify-content-center flex-column'
                                >
                                    <Title>
                                        {props?.content_group.title}
                                    </Title>
                                    <Content>
                                        <div dangerouslySetInnerHTML={{ __html: props?.content_group.text }}></div>
                                        <span className='icon-markup'></span>
                                    </Content>
                                    {
                                        props?.content_group.button && (
                                        <Button onClick={handleClick} label={props?.content_group.button.title}/>
                                        )
                                    }
                            </Col>
                        </Row>
                )
                : (
                    <Row className='flex-row-reverse'>
                        <Col
                            lg={{
                                span: 6,
                            }}
                            md={12}
                        >
                            <ImageWrapper>
                                <img src={props?.image_group.image.url} alt={props?.image_group.alt} />
                                <TextOverLay className='d-none d-lg-flex'>
                                    {props?.image_group.text_overlay}
                                </TextOverLay>
                            </ImageWrapper>
                        </Col>

                        <Col 
                            lg={6}
                            md={12}
                            className='d-flex flex-column align-items-start justify-content-center flex-column'
                        >
                            <Title>
                                {props?.content_group.title}
                            </Title>
                            <Content>
                                <div dangerouslySetInnerHTML={{ __html: props?.content_group.text }}></div>
                                <span className='icon-markup'></span>
                            </Content>
                            {
                                props?.content_group.button && (
                                <Button onClick={handleClick} label={props?.content_group.button.title}/>
                                )
                            }
                    </Col>
                </Row>
                )
            }
            </>
        // </Col>
    )
}

export default About

// props?.content_group.text